<template>
	<div id="app">
		<router-view/>
	</div>
</template>
<script>

export default {
	methods: {

	},
	created() {
		
	}
}
</script>
<style>
*{
	margin:0;
	padding: 0;
	font-family:PingFang;
}
@font-face {
	font-family:PingFang;
	src: url(./assets/PingFang-SC-Semibold.otf);
}
</style>
